import React, { useCallback, useState } from "react"
import {
  MenuItem,
  Select,
  FormControl,
  Typography,
  Stack,
  useTheme,
} from "@mui/material"
import { useTranslation } from "providers/i18n"
import { getFeatureDetail } from "utils/feature"

export const OrdinalSelectMenu = (props) => {
  const {
    levels = [],
    onChangeOrdinal = () => {},
    selectedOrdinal,
    label = "Select Floor",
    ...restProps
  } = props
  const [isOpen, setIsOpen] = useState(false)
  const handleChange = useCallback(
    (event) => {
      onChangeOrdinal(event.target.value)
    },
    [onChangeOrdinal]
  )
  const handleOpen = useCallback(
    (e) => {
      setIsOpen(!isOpen)
    },
    [setIsOpen, isOpen]
  )
  const { t } = useTranslation()
  const theme = useTheme()
  const { styleOverrides = {} } = theme.components[`OrdinalSelectMenu`] || {}
  const { root, text, paper, menuList, menuItem } = styleOverrides
  const { anchorOrigin, transformOrigin } =
    theme.components[`OrdinalSelectMenu`]?.defaultProps || {}
  if (levels.length === 0) return null

  return (
    <Stack spacing={0.25}>
      <Typography
        className="OrdinalSelectMenu-label"
        variant="subtitle2"
        component="p"
        sx={{ ...text, display: isOpen ? "none" : "block" }}
      >
        {t(label)}
      </Typography>
      <FormControl>
        <Select
          value={selectedOrdinal}
          onChange={handleChange}
          onClick={handleOpen}
          onClose={handleOpen}
          open={isOpen}
          sx={root}
          MenuProps={{
            anchorOrigin,
            transformOrigin,
            PaperProps: {
              sx: paper,
            },
            MenuListProps: {
              sx: menuList,
            },
          }}
          renderValue={(value) => {
            const currenLevel = levels.find((level) => {
              return level.properties?.ordinal === value
            })
            return t("Select Floor Active", {
              value: t(currenLevel?.properties.name),
            })
          }}
          {...restProps}
        >
          {levels.map((level, index) => {
            const { id, ordinal, name } = getFeatureDetail(level)
            return (
              <MenuItem
                key={`ordinal-selector-${id}`}
                selected={ordinal === selectedOrdinal}
                value={ordinal}
                sx={{
                  ...menuItem,
                  animationDelay: `${index * 6}ms`,
                }}
              >
                {t("Select Floor Option", { value: t(name) })}
              </MenuItem>
            )
          })}
        </Select>
      </FormControl>
    </Stack>
  )
}
